var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"d-flex",staticStyle:{"column-gap":"10px"}},_vm._l((_vm.buttons),function(button,idx){return _c('li',{key:idx},[_c('base-button',_vm._b({staticClass:"font-size-11 font-weight-regular",on:{"click":function($event){return _vm.onClick(button)}}},'base-button',button,false))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }